module.exports = __webpack_public_path__ + "static/img/temp_3.7495d85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp_3.png
// module id = h2f2
// module chunks = 1